module.exports = ":host .title {\n  margin-bottom: 2rem; }\n"